import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { TableBody, colors } from "@mui/material";
import { Image } from "@progress/kendo-drawing/dist/npm/drawing";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import { set } from "react-hook-form";
import NpsRating from "../../NPS";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const DnaReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const [templateTest, setTemplateTest] = useState<any>('');
    const [uuid, setUuid] = useState<any>('');

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [DnaReport, setjakReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }

        setjakReport(data);
        
        const templateMatch = data[0]?.packages && data[0]?.packages?.length > 0 
          ? data[0]?.packages?.find((packageData: any) => packageData?.name?.includes("DNA")) || data[0]?.packages[0]
          : "";
        
        setTemplateTest(templateMatch.name);
    }, [reportListParameter])

    useEffect(() => {
        setSample_Collected(DnaReport[0]?.collection_date);
        setSample_Receivedtime(DnaReport[0]?.pickup_time);
        setdesignation(DnaReport[0]?.designation);
        setGender(DnaReport[0]?.customer_gender);
        setSample_Received(DnaReport[0]?.pickup_date);
        setName(DnaReport[0]?.customer_name);
        setAge(DnaReport[0]?.customer_age);
        setDob(DnaReport[0]?.dob);
        setUuid(DnaReport[0]?.uuid)
    }, [DnaReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(DnaReport[0]?.customer_age);
        }

    }, [dob]);

    // result
    let Data = [

        {
            id: 1,
            name: "DNA Concentration (ng/μL)",
            result: " NA"
        },
        {
            id: 2,
            name: "DNA Purity",
            result: " NA"
        },
        {
            id: 3,
            name: "DNA Volume (μL)",
            result: " NA"
        },

    ];
    const [jakResult, setjakResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setjakResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "result":
                newItem.result = value;
                break;

        }
        storeData[index] = newItem;
        setTableData(storeData);
    };


    //Methodology
    const [DnaMethology, setjakMethology] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology &&
            reportListParameter?.methodology.length > 0
        ) {
            reportListParameter?.methodology?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakMethology(data);
    }, [reportListParameter]);

    const updateMethology = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...DnaMethology]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakMethology(storeData);
    }


    //Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }


    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //doctor list
    const [Dnadoctorlist, setDnadoctorlist] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setDnadoctorlist(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Dnadoctorlist]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setDnadoctorlist(storeData);
    }


    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }


    //Lmp
    const [lmp, setLmp] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.lmp_date &&
            reportListParameter?.lmp_date.length > 0
        ) {
            reportListParameter?.lmp_date?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLmp(data);
    }, [reportListParameter]);

    const updateLmp = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...lmp]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLmp(storeData);
    }

    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (DnaReport.length > 0) {
            DnaReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (DnaMethology.length > 0) {
            DnaMethology?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (lmp.length > 0) {
            lmp?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Dnadoctorlist.length > 0) {
            Dnadoctorlist?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (jakResult.length > 0) {
            jakResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };
    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
     const [tempCode, setTempCode] = useState<any>([]);

    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter]);
    const documentTitle = `${DnaReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-contain-section"> */}
                    <div className="main-content3">.</div>
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#400354" }}>DNA EXTRACTION</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>AND STORAGE</span>
                    </div>
                    <br />

                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "25px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {DnaReport[0]?.pk
                                                ? DnaReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :   <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>


                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            GA/LMP Date
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :{lmp?.map((list: any, index: number) => {
                                                return (
                                                    // <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)} />
                                                    <input
                                                        style={{
                                                            border: "none",
                                                            width: "97%",
                                                            background: "none",
                                                            fontWeight: "bold",
                                                        }}
                                                        value={list?.parameter_value}
                                                        onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)}
                                                    />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {DnaReport[0]?.center?.name && DnaReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "96%", marginLeft: "25px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:- {templateTest}</h6>
                    </div>
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            RESULT
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "100%" }}>


                        <div className="contain" style={{ border: "2px solid rgb(38, 31, 87)", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    margin: "10px 0px",
                                                    fontSize: "14px",
                                                    height: "40px",
                                                }}
                                                className={index % 2 === 0 ? 'even-row' : 'odd-row'}
                                            >
                                                <div style={{ width: "40%", marginLeft: 8 }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", fontSize: "16px" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ marginTop: "7px" }}> :</div>
                                                {list?.risk !== "green" ?
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                        <GrammarlyEditorPlugin>
                                                            <input
                                                                style={{ border: "none", width: "100%", fontWeight: "bold", background: "none", marginTop: "7px", fontSize: "16px" }}
                                                                value={list?.result}
                                                                onChange={(e: any) =>
                                                                    updateRow(index, "result", e.target.value, list)
                                                                }
                                                            />
                                                        </GrammarlyEditorPlugin>
                                                    </div> :
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                    </div>
                                                }
                                            </div>

                                        </>
                                    );
                                })}

                        </div>
                    </div>


                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            METHODOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {DnaMethology.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", fontSize: "16px" }}
                                            rows={4}
                                            cols={117}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMethology(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ width: "90%", marginLeft: "50px", fontSize: "16px" }}>
                        <p>
                            <b>Note: The extracted DNA will be stored at the laboratory for 2 years.</b>
                        </p>

                    </div>
                    <div>
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            DISCLAIMER
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "16px" }}>
                        <ol>
                            <li>
                                As per the PRE-NATAL DIAGNOSTIC TECHNIQUES (REGULATIONS & PREVENTION OF MISUSE) AMENDMENT ACT 2002,sex determination shall not be done for all prenatal samples.
                            </li>
                        </ol>

                    </div>
                    <div className="page-footer tablecontent" >

                        <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around',marginTop:"-20px"}} className="marginB1">
                            {Dnadoctorlist && Dnadoctorlist?.length > 0 && Dnadoctorlist?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                )
                            })}
                        </div>
                        <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                            {Dnadoctorlist && Dnadoctorlist?.length > 0 && Dnadoctorlist?.filter((doctor: any) => doctor?.parameter_url !== "").map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                border: "none",
                                                textAlign: "center",
                                                minHeight: "90px",
                                                width: "100%",
                                                whiteSpace: "pre-line",
                                            }}
                                            contentEditable={true}
                                            onInput={(e) => updateDoctorList(list?.id, e.currentTarget.textContent, index, "free_text", list)}
                                        >
                                            {list?.parameter_value}
                                        </div>
                                    </>
                                )
                            })}
                        </div>

                        {/* footer area */}
                        <div style={{ padding: "20px",marginTop:"-40px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                    {
                                            uuid && (
                                                <div className="hide-section-rating">
                                                    <NpsRating bookingId={firstP} uuid={uuid} />
                                                </div>
                                            )
                                        }
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(DnaReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}
